export class PlanoSaudeProcedimentoPk {

    idPlanoSaude: number = 0;

    idProcedimento: number = 0;

    constructor() {
    }
}
